import React, { useState, useEffect } from "react";
import { Pie } from "@ant-design/plots";
import { Empty, Spin } from "antd";

const PosDonutPlotChart = (props) => {
  // const data = props.data.map((item) => ({
  //   type: item.bankName,
  //   value: item.commissionAmount,
  // }));

  // CommissionAmount değeri 0 olan verilerimi getirmez
  const data = props.data
    .filter((item) => item.commissionAmount !== 0)
    .map((item) => ({
      type: item.bankName,
      value: item.commissionAmount,
    }));

  if (data.length === 0) {
    return <Empty description="Veri Yok" />;
  }

  if (props.isLoading) {
    return (
      <div style={{ textAlign: "center", position: "relative" }}>
        <Spin size="small" />
      </div>
    );
  }

  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    label: {
      //type: "inner",
      //offset: "-50%",
      content: (item) => {
        // if (item.value === 0) {
        //   return "";
        // }
        const formattedValue = new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
          minimumFractionDigits: 2,
        }).format(item.value);
        return formattedValue;
      },
      // style: {
      //   textAlign: "center",
      //   fontSize: 14,
      // },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "15px",
          fill: "#000000",
        },
        content: `BANKALARA GÖRE\nKOMİSYON TUTARLARI`,
      },
    },
    tooltip: {
      customContent: (title, data) => {
        const content = data
          .map((item) => {
            const formattedValue = new Intl.NumberFormat("tr-TR", {
              currency: "TRY",
              minimumFractionDigits: 2,
            }).format(item.value);

            return `
            <div style="margin-bottom: 10px;" >
                <span style="font-weight: bold; color: ${item.color}; margin-right: 8px;">●</span>
                <spa >${item.name} :</span>
                <span style="float: right; margin-left: 10px; text-align: right;">${formattedValue} TL</span>
              </div>
            `;
          })
          .join("");

        return `
        <div style="margin-top: 10px;">${title}</div>
        <div style="margin-top: 20px; margin-bottom: 15px;">${content}</div>
        `;
      },
    },
  };

  return (
    <div>
      <Pie {...config} />
    </div>
  );
};

export default PosDonutPlotChart;
